import React, { useEffect, useState, useRef } from "react";
import { Comment } from '@ant-design/compatible';
import { List, Input, Form, Button, message, Tabs, Row, Col, Spin } from "antd";
import { FileImageOutlined } from "@ant-design/icons";
import PictureUpload from "../../file-upload/PictureUpload";
import moment from "moment-jalaali";
import strings from "../../../utils/strings";
import InsuranceDetailsInfo from "./InsuranceDetailsInfo";
import DeliveryStateHistory from "./DeliveryStateHistory";
import axiosInstance from "../../../axios";
import config from "../../../config";
import { saveAs } from "file-saver";
import InsuranceHistoryLog from "./InsuranceHistoryLog";
import CrmCalls from "../../user-business-report/crmReport/crmDetails/CrmCalls";
import InsuranceInfoHistory from "./InsuranceInfoHistory";
import { usePersistedStore } from "../../../store/persisted-store";
import { useGeneralStore } from "../../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../../store/slices/createReportsSlice";
import InsuranceShowLogsRequestEvents from "./InsuranceShowLogsRequestEvents";
import CrmEndorsementTable from "../../user-business-report/crmReport/crmEndorsement/CrmEndorsementTable";





const { TextArea } = Input;
const { TabPane } = Tabs;

export default function InsuranceDetailsForm({ item }) {

  const general = useGeneralStore();
  const reports = useReportsStore();
  const { auth, business } = usePersistedStore();
  const comments = reports.underReview.comments;
  const commentLoading = reports.underReview.loading;
  const loading = reports.insuranceDetails.loading;
  const userInfo = auth.userInfo;
  const prevRequestId = general.view.insuranceDetailsPrevRequestId;
  const token = business.currentBusiness.token;
  const [messageVal, setMessageVal] = useState("");
  const [tabId, setTabId] = useState("1");
  const pictureUploader = useRef(null);

  let userResources;
  if (userInfo) {
    userResources = userInfo?.Resources;
  }

  function tabIdSetter(key) {
    setTabId(key);
    switch (key) {
      case "1":
        break;
      case "2":
        reports.getInsuranceDetailsComments(item.requestId);
        break;
      case "3":
        reports.getDeliveryStateHistory(item.requestId);
        break;
      case "6":
        reports.getCrmCalls(item.requestId);
        break;
        case "7":
        reports.getLogsRequestEvent(item.requestId);
        break
      case "8":
        reports.getCrmEndorsements(item.requestId);
        break;
      default:
        break;
    }
  }

  const error = () => {
    message.error("کامنت خالی قابل ثبت نمی باشد.");
  };
  const handleSubmit = () => {
    if (!messageVal) {
      error();
      return;
    }
    reports.postInsuranceDetailsComment({
      insuranceRequestId: item.requestId,
      message: messageVal,
      attachFile: pictureUploader.current.state.fileList
    }
      // item.requestId,
      // messageVal,
      // pictureUploader.current.state.fileList

    );
    pictureUploader.current.setState({ fileList: [] });
    setMessageVal("");
  };
  const DownloaderAttachment = async (attch) => {
    try {
      const resp = await axiosInstance({
        method: "get",
        baseURL: config.apiUrls(),
        url: `/v1/business/insurance/comment/file/${attch}`,
        headers: {
          token
        },
        responseType: 'blob',
      })
      const filename = resp.headers["content-disposition"].split("filename=")[1];
      saveAs(resp.data, filename);
    } catch (error) {
    }
  };

  useEffect(() => {
    if (item?.requestId && prevRequestId !== item.requestId) {
      general.SetInsuranceDetailsPrevRequestId(item.requestId);
      setTabId("1");
    }
  }, [comments, item?.requestId, prevRequestId]);

  return (
    <Tabs
      centered
      defaultActiveKey="1"
      onChange={tabIdSetter}
      activeKey={tabId}
      className="comments-scroll"
    >
      <TabPane tab="جز‌ییات بیمه نامه" key="1">
        <InsuranceDetailsInfo paymentInfo={item.paymentInfo} />
      </TabPane>
      {userInfo &&
        userInfo.Resources &&
        userInfo.Resources.includes("BusinessReadComment") && (
          <TabPane tab="یادداشت ها" key="2">
            <Spin spinning={commentLoading}>
              {comments && comments.length > 0 && (
                <List
                  itemLayout="horizontal"
                  loading={loading}
                  pagination={{
                    onChange: page => { },
                    pageSize: 3,
                  }}
                  dataSource={comments}
                  renderItem={(item) => {
                    return (
                      <Comment
                        content={
                          <Row>
                            <Col xs={24}>
                              <p>{item.Message}</p>
                            </Col>
                            <Col xs={24} >
                              {item.FileIds.length > 0 && (
                                <>
                                  <ol style={{ textAlign: "left" }} >
                                    {item.FileIds.map((attch) => {
                                      return (
                                        <li
                                          style={{ cursor: "pointer", display: "inline", marginLeft: "10px" }}
                                          key={attch}
                                          onClick={() => DownloaderAttachment(attch, item.Id)}
                                        >
                                          <FileImageOutlined style={{ fontSize: "16px", color: "#40a9ff" }} />
                                        </li>
                                      );
                                    })}
                                  </ol>
                                </>
                              )}
                            </Col>
                          </Row>
                        }
                        author={item.SenderFullName}
                        style={{
                          marginBottom: "5px",
                          backgroundColor:
                            "#" +
                            (0x1000000 + (item.SenderTypeId + 256) * 0xffffff)
                              .toString(16)
                              .substr(1, 6) +
                            "1a",
                        }}
                        datetime={strings.getFarsiNum(
                          moment(item.CreationTime).format(
                            "jYYYY/jMM/jDD - HH:mm"
                          )
                        )}
                      />
                    );
                  }}
                />
              )}
              <Comment>
                <Form.Item>
                  <TextArea
                    rows={3}
                    focus="end"
                    value={messageVal}
                    onChange={(e) => setMessageVal(e.target.value)}
                  />
                </Form.Item>
                <PictureUpload ref={pictureUploader} count={5} />
                <Form.Item>
                  <Button
                    type="primary"
                    htmltype="submit"
                    className="btn btn-primary waves-effect waves-light"
                    onClick={handleSubmit}
                    style={{ width: "100%" }}
                  >
                    <i className={commentLoading ? "bx bx-loader bx-spin" : "bx bx-check-double "}></i>
                    &nbsp;&nbsp;افزودن یادداشت
                  </Button>
                </Form.Item>
              </Comment>
            </Spin>
          </TabPane>
        )}
      <TabPane tab="روند تحویل" key="3">
        <DeliveryStateHistory />
      </TabPane>
      <TabPane tab="تغییرات اطلاعات" key="4">
        <InsuranceHistoryLog tab={tabId} />
      </TabPane>
      {/* biome-ignore lint/complexity/useOptionalChain: <explanation> */}
      {userResources && userResources.includes("CRM") && 
        <TabPane tab="تغییرات درخواست" key="5">
          <InsuranceInfoHistory tab={tabId} />
        </TabPane>}
      <TabPane tab="تماس" key="6">
        <CrmCalls Item={{
          ...item,
          UserId: userInfo?.UserId
        }} />
      </TabPane>
      <TabPane tab="رویداد درخواست ها" key="7">
        <InsuranceShowLogsRequestEvents tab={tabId} />
      </TabPane>
      <TabPane tab="الحاقیه" key="8">
        <CrmEndorsementTable />
      </TabPane>
    </Tabs>
  );
}
